import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type BulkDeleteResult = {
  deletedIds: string[];
  skippedIds: string[];
};

export const useBulkDeleteCompanyAppendices = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: BulkDeleteResult },
    Error,
    string[]
  >({
    mutationFn: appendixIds =>
      api.post<BulkDeleteResult>('company-appendices/bulk-delete', { appendixIds }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-appendices'] });
    },
  });

  const bulkDeleteCompanyAppendices = async (appendixIds: string[]) => {
    const response = await mutateAsync(appendixIds);
    return response.data;
  };

  return {
    bulkDeleteCompanyAppendices,
    isLoading,
  };
};
